
import { StorageLocationDto, CreateStorageLocationDto, UpdateStorageLocationDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { storageLocationService, StorageLocationsFilters } from '@services/storageLocationService'

const { reducer, actions, thunks } = baseCrudReducer<
  StorageLocationDto,
  CreateStorageLocationDto,
  UpdateStorageLocationDto,
  StorageLocationsFilters
>('storageLocation', storageLocationService)

export default reducer

export const { setFilters: setStorageLocationFilters } = actions

export const {
  getAll: getStorageLocations,
  create: createStorageLocation,
  update: updateStorageLocation,
  remove: removeStorageLocation,
} = thunks
